import { render, staticRenderFns } from "./connect_box.vue?vue&type=template&id=f261af42&scoped=true"
import script from "./connect_box.vue?vue&type=script&lang=js"
export * from "./connect_box.vue?vue&type=script&lang=js"
import style0 from "./connect_box.vue?vue&type=style&index=0&id=f261af42&prod&scoped=true&lang=css"
import style1 from "./connect_box.vue?vue&type=style&index=1&id=f261af42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f261af42",
  null
  
)

export default component.exports